import {
    UPDATE_VIDEO_CURRENT_TIME,
    SET_WAVEFORM_ACTIVE,
    SET_VIDEO_DURATION
} from '../actions/types';

const initialState = {
    videoCurrentTime:0, //播放當時的時間
    waveformActive:true, //大環進托拉
    videoDuration:0,  //總時間
};

export default function(state = initialState, action) {
    switch (action.type) {

        case SET_VIDEO_DURATION:
            return {
                ...state,
                videoDuration: action.payload
            };

        case SET_WAVEFORM_ACTIVE:
            return {
                ...state,
                waveformActive: action.payload
            };



        case UPDATE_VIDEO_CURRENT_TIME:
            return {
                ...state,
                videoCurrentTime: action.payload
            };


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/videoPlayerReducer.js